import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TabContent, TabPane } from 'reactstrap';
import { TabBar } from '../../../shared/components';
import Documents from './Documents';
import Missions from './Missions';
import MICICases from './MICICases';
import Tasks from './Tasks';
import Grievances from './Grievances';

interface Props {
  tab: number;
}

const OperationTabsContainer: React.FC<Props> = ({ tab }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(1);
  const tabHeaders = [
    { id: 1, text: t('tasks'), htmlId: 'tabTasks' },
    { id: 2, text: t('documents'), htmlId: 'tabDocuments' },
    { id: 3, text: t('missions'), htmlId: 'tabMission' },
    { id: 4, text: t('miciCases'), htmlId: 'tabMici' },
    { id: 5, text: t('grievances'), htmlId: 'tabGrievances' },
  ];
  const toogle = (tb: number) => {
    if (activeTab !== tb) {
      setActiveTab(tb);
    }
  };

  useEffect(() => {
    if (activeTab !== tab) {
      const index = +tab;
      setActiveTab(index);
    }
  }, [tab]);

  return (
    <>
      <TabBar
        id="operationTabBar"
        tabSelected={activeTab}
        setTabSelected={toogle}
        headers={tabHeaders}
      />
      <TabContent activeTab={activeTab}>
        <TabPane tabId={1}>
          <Tasks />
        </TabPane>
        <TabPane tabId={2}>
          <Documents />
        </TabPane>
        <TabPane tabId={3}>
          <Missions />
        </TabPane>
        <TabPane tabId={4}>
          <MICICases />
        </TabPane>
        <TabPane tabId={5}>
          <Grievances />
        </TabPane>
      </TabContent>
    </>
  );
};

export default OperationTabsContainer;
